import { createReducer, createNamespacer } from '../../commons/js/utils/reducer';
import { fromPairs as _fromPairs } from 'lodash';

const initialState = {
    pipelineReference: [],
    currentPage: 1,
    pageCount: 0,
    isLoading: true,
    packageOptions: [],
    pdfView: false,
    error: "",
    highlightPipelineState:'',
    url:'',
    package: { label: '', value: '' },
    packageDetails: {},
    replacePipelineId: 0,
    drawingLoading: false,
    pipelineDrawing: {
        name: "",
        value: "",
        error: "",
        showError: "",
    },
}

const listPipelines = createNamespacer("PIPELINES_LIST")

const listPipelinesReducer = createReducer(initialState, {
    [listPipelines("SET_PIPELINES")]:(state, action) => {
        return {
            ...state,
            pipelineReference: action.payload.value,
            pageCount: action.payload.pages,
        }
    },
    [listPipelines("SET_PACKAGE_OPTION")]: (state, action) => {
        return {
            ...state,
            package: action.payload.value,
        }

    },
    [listPipelines("SET_REPLACE_PIPELINE_ID")]:(state, action) => {
        return {
            ...state,
            replacePipelineId: action.payload.id,
        }
    },
    [listPipelines("SET_REPLACE_PIPELINE_DRAWING")]:(state, action) => {
        return {
            ...state,
            pipelineDrawing:{
                ...state.pipelineDrawing,
                value: action.payload.value,
                name: action.payload.value.name,
            },
        }
    },
    [listPipelines("CLEAR_REPLACE_FORM")]: (state, action) => {
        return {
            ...state,
            pipelineDrawing: {
                ...initialState.pipelineDrawing,
            }
        }
    },
    [listPipelines("SET_PIPELINE_PDF")]: (state, action) => {
        return {
            ...state,
            url: action.payload.value.drawing,
        }
    },
    [listPipelines("SET_DRAWING_LOADING")]: (state, action) => {
        return {
            ...state,
            drawingLoading: action.payload.value,
        }
    },
    [listPipelines("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [listPipelines("SET_LOADING")]:(state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [listPipelines("HIGHLIGHT_PIPELINE")]: (state, action) => {
        return {
            ...state,
            highlightPipelineState: action.payload.highlightPipeline,
        }
    },
    [listPipelines("SET_PAGE")]:(state, action) => {
        return {
            ...state,
            currentPage: action.payload.value,
        }
    },
    [listPipelines("CLEAR_PACKAGE_OPTIONS")]:(state, action) => {
        return {
            ...state,
            packageOptions: initialState.packageOptions,
        }
    },
    [listPipelines("SET_PACKAGE_OPTIONS")]:(state, action) => {
        return {
            ...state,
            packageOptions: [
                ...state.packageOptions,
                ...action.payload.value
            ],
        }
    },
    [listPipelines("SET_PACKAGE_DETAILS")]:(state, action) => {
        return {
            ...state,
            packageDetails: action.payload.value,
        }
    },
    [listPipelines("SET_PDF_VIEW")]: (state, action) => {
        return {
            ...state,
            pdfView: action.payload.value,
        }
    },
    [listPipelines("CLEAR_PDF_URL")]: (state, action) => {
        return {
            ...state,
            url: "",
        }
    },
    [listPipelines("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },
});

export default listPipelinesReducer